import { AddTeamRequest, AddTeamResponse, apiPost } from 'api';

export const addTeam = (request: AddTeamRequest): Promise<AddTeamResponse> =>
  apiPost<AddTeamResponse, AddTeamRequest>('admin/teams', request);
